<div class="service-call-page" *ngIf="!loading && customer">
  <!-- Header -->
  <div class="sc-header">
    <button mat-icon-button (click)="goBack()" class="back-btn">
      <mat-icon>arrow_back</mat-icon>
    </button>
    <div class="sc-header-info">
      <h1>{{ isEdit ? 'Einsatz bearbeiten' : 'Neuer Einsatz' }}</h1>
      <span class="sc-customer">{{customer.name}}</span>
    </div>
    <span class="header-spacer"></span>
    <button mat-stroked-button class="mode-toggle" (click)="toggleWizardMode()">
      <mat-icon>{{wizardMode ? 'view_agenda' : 'linear_scale'}}</mat-icon>
      {{wizardMode ? 'Formular' : 'Wizard'}}
    </button>
  </div>

  <!-- Validation Errors -->
  <div class="validation-errors" *ngIf="validationErrors.length > 0">
    <mat-icon>warning</mat-icon>
    <div class="error-list">
      <span *ngFor="let err of validationErrors">{{err}}</span>
    </div>
  </div>

  <!-- Stepper (wizard mode only) -->
  <div class="stepper-bar" *ngIf="wizardMode">
    <div class="step-dot" *ngFor="let label of stepLabels; let i = index"
         [class.active]="step === i" [class.done]="step > i" (click)="goToStep(i)">
      <div class="dot">
        <mat-icon *ngIf="step > i" class="done-icon">check</mat-icon>
        <span *ngIf="step <= i">{{i + 1}}</span>
      </div>
      <span class="step-label">{{label}}</span>
    </div>
  </div>

  <!-- ==================== Step 0: Auftrag & Ist-Zustand & Zeiten ==================== -->
  <div class="step-content" *ngIf="!wizardMode || step === 0">
    <div class="step-card">
      <h2><mat-icon>assignment</mat-icon> Auftragsinformationen</h2>

      <mat-form-field appearance="outline" class="full-w" [class.field-invalid]="stepValidated[0] && !title.trim()">
        <mat-label>Titel / Kurzbeschreibung *</mat-label>
        <input matInput [(ngModel)]="title" placeholder="z.B. Sicherung getauscht Hauptverteiler" [matAutocomplete]="titleAuto">
        <mat-autocomplete #titleAuto="matAutocomplete">
          <mat-option *ngFor="let option of titleSuggestions" [value]="option">{{option}}</mat-option>
        </mat-autocomplete>
      </mat-form-field>

      <mat-form-field appearance="outline" class="full-w" [class.field-invalid]="stepValidated[0] && !selectedEquipmentId">
        <mat-label>Anlage / Verteiler *</mat-label>
        <mat-select [(ngModel)]="selectedEquipmentId">
          <mat-option *ngFor="let eq of equipments" [value]="eq.id">
            {{eq.name}} <span *ngIf="eq.location" class="option-hint">– {{eq.location}}</span>
          </mat-option>
        </mat-select>
        <mat-icon matPrefix>electrical_services</mat-icon>
      </mat-form-field>

      <mat-form-field appearance="outline" class="full-w">
        <mat-label>Einsatzdatum</mat-label>
        <input matInput [matDatepicker]="serviceDatePicker" [(ngModel)]="serviceDate">
        <mat-datepicker-toggle matSuffix [for]="serviceDatePicker"></mat-datepicker-toggle>
        <mat-datepicker #serviceDatePicker></mat-datepicker>
      </mat-form-field>

      <mat-form-field appearance="outline" class="full-w">
        <mat-label>Techniker</mat-label>
        <mat-select [(ngModel)]="assignedUserIds" multiple>
          <mat-option *ngFor="let user of users" [value]="user.id">
            {{user.userName}} <span *ngIf="user.email" class="option-hint">– {{user.email}}</span>
          </mat-option>
        </mat-select>
        <mat-icon matPrefix>group</mat-icon>
      </mat-form-field>

      <h3 class="section-subtitle"><mat-icon>report_problem</mat-icon> Ist-Zustand / Grund des Einsatzes</h3>
      <mat-form-field appearance="outline" class="full-w">
        <mat-label>Wieso wurde der Einsatz durchgeführt?</mat-label>
        <textarea matInput [(ngModel)]="initialSituation" rows="3"
                  placeholder="z.B. Kunde meldet Stromausfall im 2. OG..."
                  [matAutocomplete]="situationAuto"></textarea>
        <mat-autocomplete #situationAuto="matAutocomplete">
          <mat-option *ngFor="let option of situationSuggestions" [value]="option">{{option}}</mat-option>
        </mat-autocomplete>
      </mat-form-field>

      <h3 class="section-subtitle"><mat-icon>schedule</mat-icon> Zeiterfassung</h3>
      <div class="time-grid">
        <mat-form-field appearance="outline" class="time-field">
          <mat-label>Abfahrt Büro</mat-label>
          <input matInput type="time" [(ngModel)]="departureFromOffice">
          <mat-icon matPrefix>departure_board</mat-icon>
        </mat-form-field>
        <mat-form-field appearance="outline" class="time-field">
          <mat-label>Ankunft vor Ort</mat-label>
          <input matInput type="time" [(ngModel)]="arrivalTime">
          <mat-icon matPrefix>login</mat-icon>
        </mat-form-field>
        <mat-form-field appearance="outline" class="time-field">
          <mat-label>Abfahrt vor Ort</mat-label>
          <input matInput type="time" [(ngModel)]="departureTime">
          <mat-icon matPrefix>logout</mat-icon>
        </mat-form-field>
        <mat-form-field appearance="outline" class="time-field">
          <mat-label>Rückkehr Büro</mat-label>
          <input matInput type="time" [(ngModel)]="returnToOffice">
          <mat-icon matPrefix>home</mat-icon>
        </mat-form-field>
      </div>

      <div class="time-calc-display" *ngIf="hasAnyTimeEntry">
        <div class="calc-item" [class.pending]="!arrivalTime || !departureTime">
          <mat-icon>build</mat-icon>
          <span>Arbeitszeit</span>
          <strong>{{durationText}}</strong>
          <small>Ankunft bis Abfahrt vor Ort</small>
        </div>
        <div class="calc-item" [class.pending]="!(departureFromOffice && arrivalTime) && !(departureTime && returnToOffice)">
          <mat-icon>directions_car</mat-icon>
          <span>Fahrzeit</span>
          <strong>{{travelTimeText}}</strong>
          <small>Hin- und Rückfahrt</small>
        </div>
        <div class="calc-item" [class.pending]="!departureFromOffice || !returnToOffice">
          <mat-icon>timeline</mat-icon>
          <span>Gesamt unterwegs</span>
          <strong>{{totalTimeText}}</strong>
          <small>Abfahrt Büro bis Rückkehr</small>
        </div>
      </div>

      <h3 class="section-subtitle"><mat-icon>euro</mat-icon> Regiestunden</h3>
      <div class="regie-rate-hint" *ngIf="hourlyRates.length === 0">
        <mat-icon>info</mat-icon>
        <span>Beim Kunden sind noch keine Stundensätze hinterlegt. Du kannst hier trotzdem einen freien Satz eintragen.</span>
      </div>
      <div class="regie-table" *ngIf="regieLines.length > 0">
        <div class="regie-row regie-head">
          <span>Tätigkeit</span>
          <span>Stunden</span>
          <span>Satz</span>
          <span>Summe</span>
          <span></span>
        </div>
        <div class="regie-row" *ngFor="let line of regieLines; let i = index">
          <span>{{line.label}}</span>
          <span>{{line.hours | number:'1.2-2'}} h</span>
          <span>{{line.hourlyRate | number:'1.2-2'}} €/h</span>
          <strong>{{line.hours * line.hourlyRate | currency:'EUR':'symbol':'1.2-2'}}</strong>
          <button mat-icon-button color="warn" (click)="removeRegieLine(i)" matTooltip="Zeile entfernen">
            <mat-icon>close</mat-icon>
          </button>
        </div>
        <div class="regie-total">
          <span>Gesamt</span>
          <strong>{{getRegieTotal() | currency:'EUR':'symbol':'1.2-2'}}</strong>
        </div>
      </div>

      <div class="regie-add-row">
        <mat-form-field appearance="outline" class="regie-rate-select">
          <mat-label>Stundensatz</mat-label>
          <mat-select [(ngModel)]="newRegieRateId" (ngModelChange)="onRegieRateSelected($event)">
            <mat-option [value]="null">Freier Satz</mat-option>
            <mat-option *ngFor="let rate of hourlyRates" [value]="rate.id">
              {{rate.label}} · {{rate.hourlyRate | number:'1.2-2'}} €/h
            </mat-option>
          </mat-select>
        </mat-form-field>
        <mat-form-field appearance="outline" class="regie-label-field">
          <mat-label>Tätigkeit</mat-label>
          <input matInput [(ngModel)]="newRegieLabel" placeholder="z.B. Monteur">
        </mat-form-field>
        <mat-form-field appearance="outline" class="regie-small-field">
          <mat-label>Stunden</mat-label>
          <input matInput type="number" [(ngModel)]="newRegieHours" min="0" step="0.25">
        </mat-form-field>
        <mat-form-field appearance="outline" class="regie-small-field">
          <mat-label>€/h</mat-label>
          <input matInput type="number" [(ngModel)]="newRegieRate" min="0" step="0.01">
        </mat-form-field>
        <button mat-mini-fab color="primary" (click)="addRegieLine()" [disabled]="!newRegieLabel.trim() || newRegieHours <= 0">
          <mat-icon>add</mat-icon>
        </button>
      </div>
    </div>
  </div>

  <!-- ==================== Step 1: Probleme & Lösungen ==================== -->
  <div class="step-content" *ngIf="!wizardMode || step === 1">
    <div class="step-card">
      <h2><mat-icon>bug_report</mat-icon> Festgestellte Probleme & Lösungen</h2>

      <div class="problems-list" *ngIf="problems.length > 0">
        <div class="problem-card" *ngFor="let prob of problems; let i = index">
          <div class="problem-header">
            <span class="problem-num">Problem {{i + 1}}</span>
            <button mat-icon-button color="warn" (click)="removeProblem(i)">
              <mat-icon>close</mat-icon>
            </button>
          </div>
          <p class="problem-desc">{{prob.description}}</p>
          <p class="problem-solution" *ngIf="prob.solution">
            <mat-icon class="solution-icon">check_circle</mat-icon> {{prob.solution}}
          </p>
        </div>
      </div>

      <div class="empty-hint" *ngIf="problems.length === 0">
        <mat-icon>info_outline</mat-icon>
        <span>Beschreiben Sie die festgestellten Probleme und deren Lösungen.</span>
      </div>

      <div class="add-problem-form">
        <mat-form-field appearance="outline" class="full-w">
          <mat-label>Problem beschreiben</mat-label>
          <textarea matInput [(ngModel)]="newProblemDesc" rows="2"
                    placeholder="z.B. Sicherung F3 im Hauptverteiler ausgelöst"
                    [matAutocomplete]="problemAuto"></textarea>
          <mat-autocomplete #problemAuto="matAutocomplete">
            <mat-option *ngFor="let option of problemSuggestions" [value]="option">{{option}}</mat-option>
          </mat-autocomplete>
        </mat-form-field>
        <mat-form-field appearance="outline" class="full-w">
          <mat-label>Lösung (optional)</mat-label>
          <textarea matInput [(ngModel)]="newProblemSolution" rows="2"
                    placeholder="z.B. Sicherung getauscht, Ursache: Überlast durch Heizlüfter"
                    [matAutocomplete]="solutionAuto"></textarea>
          <mat-autocomplete #solutionAuto="matAutocomplete">
            <mat-option *ngFor="let option of solutionSuggestions" [value]="option">{{option}}</mat-option>
          </mat-autocomplete>
        </mat-form-field>
        <button mat-raised-button color="primary" (click)="addProblem()" [disabled]="!newProblemDesc.trim()">
          <mat-icon>add</mat-icon> Problem hinzufügen
        </button>
      </div>
    </div>
  </div>

  <!-- ==================== Step 2: Durchgeführte Arbeiten ==================== -->
  <div class="step-content" *ngIf="!wizardMode || step === 2">
    <div class="step-card">
      <h2><mat-icon>build</mat-icon> Durchgeführte Arbeiten</h2>

      <mat-form-field appearance="outline" class="full-w">
        <mat-label>Allgemeine Beschreibung (optional)</mat-label>
        <textarea matInput [(ngModel)]="description" rows="2"
                  placeholder="Allgemeine Beschreibung der Arbeiten..."></textarea>
      </mat-form-field>

      <h3 class="work-items-header"><mat-icon>checklist</mat-icon> Erledigte Arbeiten</h3>
      <div class="work-items-list" *ngIf="workItems.length > 0">
        <div class="work-item-row" *ngFor="let item of workItems; let i = index">
          <span class="wi-num">{{i + 1}}.</span>
          <span class="wi-text">{{item}}</span>
          <button mat-icon-button color="warn" (click)="workItems.splice(i, 1)">
            <mat-icon>close</mat-icon>
          </button>
        </div>
      </div>
      <div class="work-item-add-row">
        <mat-form-field appearance="outline" class="flex-grow">
          <mat-label>Arbeitspunkt hinzufügen</mat-label>
          <input matInput [(ngModel)]="newWorkItem" placeholder="z.B. Sicherung F3 getauscht"
                 (keyup.enter)="addWorkItem()" [matAutocomplete]="workAuto">
          <mat-autocomplete #workAuto="matAutocomplete">
            <mat-option *ngFor="let option of workSuggestions" [value]="option">{{option}}</mat-option>
          </mat-autocomplete>
        </mat-form-field>
        <button mat-mini-fab color="primary" (click)="addWorkItem()" [disabled]="!newWorkItem.trim()">
          <mat-icon>add</mat-icon>
        </button>
      </div>
    </div>
  </div>

  <!-- ==================== Step 3: Material ==================== -->
  <div class="step-content" *ngIf="!wizardMode || step === 3">
    <div class="step-card">
      <h2><mat-icon>inventory_2</mat-icon> Verwendetes Material</h2>

      <div class="mat-list" *ngIf="materials.length > 0">
        <div class="mat-row" *ngFor="let mat of materials; let i = index">
          <div class="mat-info">
            <strong>{{mat.name}}</strong>
            <span class="mat-qty">{{mat.quantity}} {{mat.unit}}</span>
            <span class="mat-qty" *ngIf="mat.unitPrice && mat.unitPrice > 0">{{mat.unitPrice | currency:'EUR':'symbol':'1.2-2'}} / {{mat.unit}}</span>
          </div>
          <button mat-icon-button color="warn" (click)="removeMaterial(i)">
            <mat-icon>close</mat-icon>
          </button>
        </div>
      </div>

      <div class="empty-hint" *ngIf="materials.length === 0">
        <mat-icon>info_outline</mat-icon>
        <span>Noch kein Material hinzugefügt. Optional – kann übersprungen werden.</span>
      </div>

      <div class="add-mat-form">
        <mat-form-field appearance="outline" class="mat-name-field">
          <mat-label>Bezeichnung</mat-label>
          <input matInput [(ngModel)]="newMat.name" (keyup.enter)="addMaterial()" [matAutocomplete]="materialAuto">
          <mat-autocomplete #materialAuto="matAutocomplete">
            <mat-option *ngFor="let option of materialSuggestions" [value]="option">{{option}}</mat-option>
          </mat-autocomplete>
        </mat-form-field>
        <mat-form-field appearance="outline" class="mat-small-field">
          <mat-label>Menge</mat-label>
          <input matInput type="number" [(ngModel)]="newMat.quantity" min="1">
        </mat-form-field>
        <mat-form-field appearance="outline" class="mat-small-field">
          <mat-label>Einheit</mat-label>
          <input matInput [(ngModel)]="newMat.unit">
        </mat-form-field>
        <mat-form-field appearance="outline" class="mat-small-field">
          <mat-label>Preis</mat-label>
          <input matInput type="number" [(ngModel)]="newMat.unitPrice" min="0" step="0.01">
        </mat-form-field>
        <button mat-mini-fab color="primary" (click)="addMaterial()" [disabled]="!newMat.name.trim()">
          <mat-icon>add</mat-icon>
        </button>
      </div>

      <mat-checkbox [ngModel]="effectiveCommerciallyRelevant" (ngModelChange)="isCommerciallyRelevant = $event" [disabled]="regieLines.length > 0 || hasPricedMaterial">
        Kaufmännisch relevant
      </mat-checkbox>
    </div>
  </div>

  <!-- ==================== Step 4: Fotos & Anlagen ==================== -->
  <div class="step-content" *ngIf="!wizardMode || step === 4">
    <div class="step-card">
      <h2><mat-icon>photo_camera</mat-icon> Fotos & Anlagen</h2>

      <!-- Bereits gespeicherte Fotos (nur im Bearbeiten-Modus) -->
      <div *ngIf="serverPhotos.length > 0">
        <h3 class="section-subtitle"><mat-icon>cloud_done</mat-icon> Bereits gespeicherte Fotos</h3>
        <div class="photo-grid">
          <div class="photo-item" *ngFor="let sp of serverPhotos">
            <img [src]="serverPhotoUrl(sp.url)" [alt]="sp.fileName">
            <button mat-icon-button class="photo-remove" (click)="deleteServerPhoto(sp)" matTooltip="Foto entfernen">
              <mat-icon>close</mat-icon>
            </button>
          </div>
        </div>
      </div>

      <!-- Photos -->
      <h3 class="section-subtitle" *ngIf="photos.length > 0 || attachments.length > 0">
        <mat-icon>image</mat-icon> Fotos
      </h3>
      <div class="photo-grid" *ngIf="photos.length > 0">
        <div class="photo-item" *ngFor="let photo of photos; let i = index">
          <img [src]="photo.dataUrl" [alt]="photo.name">
          <button mat-icon-button class="photo-remove" (click)="removePhoto(i)">
            <mat-icon>close</mat-icon>
          </button>
        </div>
      </div>

      <!-- Attachments -->
      <h3 class="section-subtitle" *ngIf="attachments.length > 0">
        <mat-icon>attach_file</mat-icon> Anlagen
      </h3>
      <div class="attachment-list" *ngIf="attachments.length > 0">
        <div class="attachment-row" *ngFor="let att of attachments; let i = index">
          <mat-icon class="att-icon">{{getAttachmentIcon(att.type)}}</mat-icon>
          <span class="att-name">{{att.name}}</span>
          <button mat-icon-button color="warn" (click)="removeAttachment(i)">
            <mat-icon>close</mat-icon>
          </button>
        </div>
      </div>

      <div class="empty-hint" *ngIf="photos.length === 0 && attachments.length === 0">
        <mat-icon>info_outline</mat-icon>
        <span>Fotos und Anlagen (z.B. PDFs) hinzufügen. Optional.</span>
      </div>

      <input #photoInput type="file" accept="image/*" multiple hidden (change)="onPhotosSelected($event)">
      <input #attachmentInput type="file" accept=".pdf,.doc,.docx,.xls,.xlsx" multiple hidden (change)="onAttachmentsSelected($event)">

      <div class="photo-actions">
        <button mat-raised-button color="primary" (click)="triggerPhotoInput()">
          <mat-icon>add_a_photo</mat-icon> Foto hinzufügen
        </button>
        <button mat-raised-button (click)="triggerAttachmentInput()">
          <mat-icon>attach_file</mat-icon> Anlage hinzufügen
        </button>
      </div>
    </div>
  </div>

  <!-- ==================== Step 5: Unterschriften & Zusammenfassung ==================== -->
  <div class="step-content" *ngIf="!wizardMode || step === 5">
    <div class="step-card signature-step">

      <!-- Technician Signature (required) -->
      <h2><mat-icon>draw</mat-icon> Unterschrift Techniker *</h2>

      <mat-form-field appearance="outline" class="full-w">
        <mat-label>Name des Technikers</mat-label>
        <input matInput [(ngModel)]="techSigneeName" placeholder="Vor- und Nachname">
      </mat-form-field>

      <div class="sig-source-toggle" *ngIf="savedSignatureUrl">
        <button mat-stroked-button [class.active]="!useSavedSignature" (click)="useSavedSignature = false; initTechSignature()">
          <mat-icon>draw</mat-icon> Manuell unterschreiben
        </button>
        <button mat-stroked-button [class.active]="useSavedSignature" (click)="applySavedSignature()">
          <mat-icon>person</mat-icon> Gespeicherte Unterschrift verwenden
        </button>
      </div>

      <div *ngIf="!useSavedSignature">
        <!-- Vorhandene Unterschrift (Bearbeiten): bleibt erhalten, solange nicht neu gezeichnet -->
        <div *ngIf="isEdit && existingTechSignatureDataUrl && !techSigned" class="saved-sig-preview">
          <img [src]="existingTechSignatureDataUrl" alt="Vorhandene Unterschrift" class="saved-sig-img">
          <p class="sig-hint">Vorhandene Unterschrift wird beibehalten. Unten neu zeichnen, um sie zu ersetzen.</p>
        </div>
        <p class="sig-hint">Bitte hier unterschreiben:</p>
        <div class="signature-canvas-wrapper" [class.field-invalid]="stepValidated[5] && !hasTechSignature">
          <canvas #techCanvas class="signature-canvas"></canvas>
          <button mat-icon-button class="clear-sig" (click)="clearTechSignature()" matTooltip="Unterschrift löschen">
            <mat-icon>refresh</mat-icon>
          </button>
        </div>
      </div>

      <div *ngIf="useSavedSignature" class="saved-sig-preview">
        <img [src]="savedSignatureUrl" alt="Gespeicherte Unterschrift" class="saved-sig-img">
        <p class="sig-hint">Gespeicherte Unterschrift wird verwendet.</p>
      </div>

      <!-- Customer Signature (optional) -->
      <div class="customer-sig-toggle">
        <mat-slide-toggle [(ngModel)]="customerSignatureEnabled" (change)="toggleCustomerSignature()">
          Kunden-Unterschrift
        </mat-slide-toggle>
      </div>

      <div *ngIf="customerSignatureEnabled" class="customer-sig-block">
        <mat-form-field appearance="outline" class="full-w">
          <mat-label>Name des Kunden</mat-label>
          <input matInput [(ngModel)]="customerSigneeName" placeholder="Vor- und Nachname">
        </mat-form-field>

        <!-- Kundenbestätigung -->
        <div class="customer-acknowledgment" [class.field-invalid]="stepValidated[5] && customerSignatureEnabled && !customerAcknowledged">
          <mat-checkbox [(ngModel)]="customerAcknowledged" color="primary">
            Ich wurde über die geleisteten Stunden und durchgeführten Arbeiten aufgeklärt und bin damit einverstanden.
          </mat-checkbox>
        </div>

        <div *ngIf="isEdit && existingCustomerSignatureDataUrl && !custSigned" class="saved-sig-preview">
          <img [src]="existingCustomerSignatureDataUrl" alt="Vorhandene Kundenunterschrift" class="saved-sig-img">
          <p class="sig-hint">Vorhandene Kundenunterschrift wird beibehalten. Unten neu zeichnen, um sie zu ersetzen.</p>
        </div>
        <p class="sig-hint">Unterschrift Kunde:</p>
        <div class="signature-canvas-wrapper">
          <canvas #customerCanvas class="signature-canvas"></canvas>
          <button mat-icon-button class="clear-sig" (click)="clearCustomerSignature()" matTooltip="Unterschrift löschen">
            <mat-icon>refresh</mat-icon>
          </button>
        </div>
      </div>

      <!-- Summary -->
      <div class="summary-block">
        <h3>Zusammenfassung</h3>
        <div class="summary-row"><span>Kunde:</span><strong>{{customer.name}}</strong></div>
        <div class="summary-row"><span>Auftrag:</span><strong>{{title || '–'}}</strong></div>
        <div class="summary-row"><span>Datum:</span><strong>{{serviceDate | date:'dd.MM.yyyy'}}</strong></div>
        <div class="summary-row" *ngIf="initialSituation"><span>Ist-Zustand:</span><strong class="truncate">{{initialSituation}}</strong></div>
        <div class="summary-row"><span>Probleme:</span><strong>{{problems.length}} Einträge</strong></div>
        <div class="summary-row"><span>Arbeitszeit:</span><strong>{{durationText}}</strong></div>
        <div class="summary-row"><span>Fahrzeit:</span><strong>{{travelTimeText}}</strong></div>
        <div class="summary-row"><span>Regiestunden:</span><strong>{{regieText}}</strong></div>
        <div class="summary-row" *ngIf="workItems.length > 0"><span>Arbeitspunkte:</span><strong>{{workItems.length}} Punkte</strong></div>
        <div class="summary-row"><span>Material:</span><strong>{{materials.length}} Positionen</strong></div>
        <div class="summary-row"><span>Fotos:</span><strong>{{photos.length}} Bilder</strong></div>
        <div class="summary-row" *ngIf="attachments.length > 0"><span>Anlagen:</span><strong>{{attachments.length}} Dateien</strong></div>
      </div>
    </div>
  </div>

  <!-- Navigation -->
  <div class="nav-bar">
    <button mat-stroked-button (click)="prevStep()" *ngIf="wizardMode && step > 0">
      <mat-icon>arrow_back</mat-icon> Zurück
    </button>
    <span class="nav-spacer"></span>

    <button mat-raised-button color="primary" (click)="nextStep()" *ngIf="wizardMode && step < stepLabels.length - 1" [disabled]="!canProceed">
      Weiter <mat-icon>arrow_forward</mat-icon>
    </button>

    <button mat-raised-button color="accent" (click)="saveAndExport()"
            *ngIf="!wizardMode || step === stepLabels.length - 1"
            [disabled]="saving" class="save-btn">
      <mat-spinner *ngIf="saving" diameter="18" class="btn-spinner"></mat-spinner>
      <mat-icon *ngIf="!saving">picture_as_pdf</mat-icon>
      {{ isEdit ? 'Aktualisieren & PDF' : 'Speichern & PDF' }}
    </button>
  </div>
</div>

<!-- Loading -->
<div *ngIf="loading" class="loading-page">
  <mat-spinner diameter="48"></mat-spinner>
</div>
